const state = {
  spotify: {
    access_token: '',
    state: "",
    device_id: "",
    user: {},
    playlist: {},
  },
  currentSong:null,
  miniplayerVisibility:false,
};
const getters = {
  SpotifyAccessToken: () => state.spotify.access_token,
  SpotifyState: () => state.spotify.state,
  SpotifyDeviceId: () => state.spotify.device_id,
  SpotifyUser: () => state.spotify.user,
  SpotifyPlaylist: () => state.spotify.playlist,
  SpotifyPlayerVisibility: () => state.miniplayerVisibility,
  SpotifyCurrentSong: () => state.currentSong,
};
const actions = {
  setMiniPlayerVisibility({commit}){
    commit('setMiniPlayerVisibility')
  },
  setCurrentSong({commit} ,data){
    commit('setCurrentSong', data)
  },
  async setSpotifyToken({ commit }, data) {
    localStorage.setItem("spotify_token", JSON.stringify(data));

    await commit("setSpotifyToken", data);
  },
  async setSpotifyState({ commit }, data) {
    await commit("setSpotifyState", data);
  },
  async setSpotifyDeviceId({ commit }, data) {
    localStorage.setItem("spotify_deviceID", JSON.stringify(data));

    await commit("setSpotifyDeviceId", data);
  },
  async setSpotifyUser({ commit }, data) {
    await commit("setSpotifyUser", data);
  },
  async setSpotifyPlaylist({ commit }, data) {
    await commit("setSpotifyPlaylist", data);
  },
};
const mutations = {
  setCurrentSong(state , data){
    state.currentSong = data
  },
  setMiniPlayerVisibility(state){
    state.miniplayerVisibility = !state.miniplayerVisibility
  },
  setSpotifyToken(state, data) {
    state.spotify.access_token = data;
    // if (state.spotify.access_token) {
    //   setTimeout(state.spotify.access_token = null, 3600);
    // } 
  },
  setSpotifyState(state, data) {
    state.spotify.state = data;
  },
  setSpotifyDeviceId(state, data) {
    state.spotify.device_id = data;
  },
  setSpotifyUser(state, data) {
    state.spotify.user = data;
  },
  setSpotifyPlaylist(state, data) {
    state.spotify.playlist = data;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
